// extracted by mini-css-extract-plugin
module.exports = {"frame":"ss7-raffle-signup_frame__2E1wD"};